var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "select-none",
      class: { "cursor-wait": _vm.addGraphLoading },
      style: { minHeight: "calc(100vh - 3.75rem - 3rem - 4px)" }
    },
    [
      _c("div", { staticClass: "flex flex-col" }, [
        _c(
          "div",
          {
            staticClass:
              "sticky top-0 z-10 px-6 py-4 border-b bg-pure-white border-slate-400"
          },
          [
            _c(
              "div",
              { staticClass: "flex items-center justify-between" },
              [
                _c("BlTextSubtitle2", {
                  staticClass: "text-slate-700",
                  attrs: { text: "Add graph from target to report" }
                }),
                _vm._v(" "),
                _c("BlIcon", {
                  staticClass: "w-6 h-6",
                  attrs: { icon: "close", clickable: "" },
                  on: {
                    clicked: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-1" },
              [
                _c("BlTextBody2", {
                  attrs: {
                    text:
                      "Drag and place the target into the report to insert its graph."
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("BlInputSearch", {
              staticClass: "w-full mt-4",
              attrs: { input: _vm.searchInput },
              on: { changed: _vm.onInputSearch }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex flex-col gap-4 px-6 py-4" }, [
          _c(
            "div",
            {
              staticClass:
                "flex items-center gap-2 pb-2 overflow-x-auto scrollbar-lg"
            },
            _vm._l(_vm.statusOptions, function(opt) {
              return _c(
                "div",
                {
                  key: opt.value,
                  staticClass:
                    "h-7.5 px-2 flex items-center flex-shrink-0 rounded-full cursor-pointer",
                  class: {
                    "bg-light-purple-400": _vm.statusFilter === opt.value,
                    "bg-slate-200 hover:bg-slate-300":
                      _vm.statusFilter !== opt.value
                  },
                  on: {
                    click: function($event) {
                      _vm.statusFilter = opt.value
                    }
                  }
                },
                [
                  _c("BlTextBody2", {
                    class: {
                      "text-pure-white": _vm.statusFilter === opt.value
                    },
                    attrs: { text: opt.label }
                  })
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          !_vm.filteredTargets.length
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "py-32 text-center" },
                  [
                    _c("BlTextBody2", {
                      attrs: { text: "Target(s) not found." }
                    })
                  ],
                  1
                )
              ])
            : _c(
                "div",
                { staticClass: "flex flex-col gap-2" },
                [
                  _vm.statusFilter === "recommended"
                    ? _c(
                        "div",
                        [
                          _c("BlTextBody2", {
                            attrs: { text: _vm.filteredTargets.length }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                " target(s) showed progress within the date range of "
                            }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text: _vm.displayDate({
                                date: _vm.report.start_date
                              })
                            }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", { attrs: { text: " to " } }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text: _vm.displayDate({
                                date: _vm.report.end_date
                              })
                            }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", { attrs: { text: "." } })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "Showing all " +
                                _vm.filteredTargets.length +
                                " target(s)"
                            }
                          })
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _vm._l(_vm.filteredTargets, function(target) {
                    return _c(
                      "div",
                      {
                        key: target.id,
                        staticClass:
                          "flex items-center justify-between gap-2 px-2 py-2 border rounded bg-pure-white border-slate-400",
                        class: { "opacity-25": _vm.dragId === target.id }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "flex items-center gap-2 truncate",
                            attrs: { title: target.name }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "cursor-grab",
                                attrs: { "data-id": target.id },
                                on: {
                                  mousedown: function($event) {
                                    return _vm.$emit("drag-start", {
                                      e: $event,
                                      client_target: target
                                    })
                                  },
                                  touchstart: function($event) {
                                    return _vm.$emit("drag-start", {
                                      e: $event,
                                      client_target: target
                                    })
                                  }
                                }
                              },
                              [
                                _c("BlIcon", {
                                  staticClass: "w-5 h-5",
                                  attrs: { icon: "drag", color: "slate-8" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "truncate",
                              attrs: { text: target.name }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex items-center gap-2" }, [
                          _c(
                            "div",
                            {
                              staticClass: "flex",
                              class: {
                                "opacity-0": target.type === "cumulative"
                              }
                            },
                            [
                              _c("BlChip", {
                                attrs: {
                                  chip:
                                    target.status === "in_progress"
                                      ? "in_acquisition"
                                      : target.status
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { title: "Add graph" } },
                            [
                              _c("BlIcon", {
                                staticClass: "w-4 h-4",
                                attrs: {
                                  icon: "plus",
                                  color: "slate-8",
                                  clickable: !_vm.addGraphLoading
                                },
                                on: {
                                  clicked: function($event) {
                                    return _vm.onAddGraph(target)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  })
                ],
                2
              )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1726e95e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1726e95e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/helper/AddGraph.vue
// module id = null
// module chunks = 